import { onDidLoad, useListen } from '@atomify/hooks';
import { BPDFormElement } from '@atoms/form-elements';

export type FormItem = {
    key: string;
    value: FormDataEntryValue;
    element: Element | null;
};

export type FormChangeCallback = {
    additions: FormItem[];
    deletions: FormItem[];
};

let previousState: FormItem[] = [];

function setPreviousState(form: { current: BPDFormElement | null }) {
    previousState = [];
    if (form.current) {
        const formData = form.current.formData();
        if (!formData) return;

        const entries = formData.entries();
        for (const [key, value] of entries) {
            const element = form.current.querySelector(`input[name="${key}"][value="${value}"]`);
            previousState.push({ key, value, element });
        }
    }
}

export function useFormChanges(
    form: { current: BPDFormElement | null },
    callback: ({ additions, deletions }: FormChangeCallback) => void,
) {
    onDidLoad(async () => {
        if (!form.current?.connected) await form.current?.componentOnReady();
        setPreviousState(form);
    });
    useListen(form, 'change', () => {
        if (form.current) {
            const formData = form.current.formData();
            if (!formData) return;

            const entries = formData?.entries();
            const currentState: FormItem[] = [];

            for (const [key, value] of entries) {
                const element = form.current.querySelector(
                    `input[name="${key}"][value="${value}"]`,
                );

                currentState.push({ key, value, element });
            }

            const additions = currentState.filter(
                (itemA) =>
                    !previousState.find(
                        (itemB) => itemB.key === itemA.key && itemB.value === itemA.value,
                    ),
            );

            const deletions = previousState.filter(
                (itemA) =>
                    !currentState.find(
                        (itemB) => itemB.key === itemA.key && itemB.value === itemA.value,
                    ),
            );

            setPreviousState(form);

            callback({ additions, deletions });
        }
    });
}
